import { useQuery } from "react-query";
import React, { memo } from "react";
import { fetchRecommendArticleChoice } from "@Services/api";

const HotArticle: React.FC = () => {
  const { data } = useQuery(
    `fetchRecommendArticleChoice_hotArticles`,
    async () => {
      const res = await fetchRecommendArticleChoice({ limit: 30, position: "searchKind" });
      if (res?.status === 12000) {
        return res.data;
      }
    },
    { initialData: { list: [] } },
  );

  const toLink = (link: string): void => {
    window.open(link, "_blank");
  };

  return (
    <section className={"relative w-full"}>
      {data.list.length !== 0 && (
        <>
          <p className={"text-24 text-left text-[#333] leading-36 font-bold mb-20"}>精選推薦</p>
          <div className={"grid grid-cols-3 gap-x-40 mb-40"}>
            {Array.isArray(data.list) &&
              data.list.map((item, index) => (
                <a
                  href={item.link}
                  key={index}
                  target="_blank"
                  className={`w-[280px] flex py-10 ${index < data.list.length - 3 ? 'border-0 border-b-1 border-solid border-[#e8e8e8]' : ''}`}
                >
                  <div
                    className={`${index < 3 ? "bg-[#3264ff]" : "bg-[#C1D0FF]"} w-16 h-16 flex items-center justify-center rounded-4 text-14 text-white mt-4`}
                  >
                    {index + 1}
                  </div>
                  <div className={"w-[246px] h-40 text-14 text-left text-[#000] leading-20 line-clamp-2 ml-12 cursor-pointer"}>{item.title}</div>
                </a>
              ))}
          </div>
        </>
      )}
    </section>
  );
};

export default memo(HotArticle);
